import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import {scrollStyles} from 'styles/shared';
import PaymentItem from './PaymentItem';

const AccordionContainer = styled.div`
  height: ${props => `${props.height}rem`};
  overflow-y: auto;
  padding-right: 2rem;
  ${scrollStyles}
`;

Accordion.propTypes = {
  height: PropTypes.number.isRequired,
  items: PropTypes.array.isRequired,
  icon: PropTypes.string
};

Accordion.defaultProps = {
  icon: 'grater'
};

function Accordion({height, items, icon}) {
  return (
    <AccordionContainer height={height}>
      {items.map(item => {
        const id = item.id;

        return <PaymentItem key={id} item={item} />;
      })}
    </AccordionContainer>
  );
}

export default Accordion;
